// extracted by mini-css-extract-plugin
module.exports = {"separator":"_2awKr","postExcerpt":"_3xxd3","postTitle":"_3tauc"};